<template>
    <div class="main">


        <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Product Management</h3>
            </div>
            <div>
                <div class="card-container">
                    <a-tabs type="card">
                        <a-tab-pane key="1">
                            <span slot="tab">
                                Product Groups
                            </span>
                            <div class="requestActions">
                                <!-- <a-form-model
                            :model="orderform"
                        >
                            <a-form-model-item>
                                <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model> -->
                                <a-button :loading="loading" @click="showGroupModal"
                                    style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                    icon="plus">
                                    Add New Group
                                </a-button>
                                <!-- <a-button @click="showAddNewOrderPage" style="height:38px; border-raduis:5px; background: #ffffff" icon="plus">
                            Request for Inventory
                        </a-button> -->

                            </div>
                            <div>
                                <a-table :columns="groupColumns" :data-source="tableGroupData" :loading="tableLoading"
                                    :pagination="pagination" class="tableStyle">

                                    <!-- <template slot="thumb" slot-scope="">
                                <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png'/>
                            </template> -->
                                    <template slot="action" slot-scope="data">
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link"
                                                @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            <a-menu slot="overlay">
                                                <a-menu-item>
                                                    <a @click="showUpdateGroupModal(data)">Edit Group?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                    </template>
                                </a-table>
                            </div>

                        </a-tab-pane>
                        <a-tab-pane key="2">
                            <span slot="tab">
                                Product Categories
                            </span>
                            <div class="requestActions">
                                <a-button @click="showCategoryModal"
                                    style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                    icon="plus">
                                    Add New Category
                                </a-button>
                            </div>
                            <div>
                                <a-table :columns="categoryColumns" :data-source="tableCategoryData"
                                    :loading="tableLoading" :pagination="pagination" class="tableStyle">
                                    <template slot="action" slot-scope="data">
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link"
                                                @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            <a-menu slot="overlay">
                                                <a-menu-item>
                                                    <a @click="showCategoryModel(data)">Edit Category?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                    </template>
                                    <template slot="isRestricted" slot-scope='data'>
                                        <div v-if="data === 'Yes'">
                                            <a-tag color="#87d068">{{data}}</a-tag>
                                        </div>
                                        <div v-else>
                                            <a-tag color="#f50">{{data}}</a-tag>
                                        </div>
                                    </template>
                                </a-table>
                            </div>
                        </a-tab-pane>
                        <!-- <a-tab-pane key="3">
                    <span slot="tab">
                        Product Suppliers
                    </span>
					<div class="requestActions">
                        <a-button @click="showSupplierModal" style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;" icon="plus">
                            Add New Supplier
                        </a-button>
                    </div>
                    <div>
                        <a-table
                        :columns="supplierColumns"
                        :data-source="tableSupplierData"
                        :loading="tableLoading"
                        :pagination="pagination"
                        class="orderTable"
                        >
                            <template slot="action" slot-scope="data">
                               <a-dropdown>
                                    <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                        <a-icon style="font-size:25px;" type="ellipsis" />
                                    </a>
                                    <a-menu slot="overlay">
                                        <a-menu-item>
                                            <a @click="showUpdateSupplierModel(data)">Edit Supplier?</a>
                                        </a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                            </template>
                           

                            <template slot="status" slot-scope="data">
                                <div v-if="data.status === 1">
                                    <a-switch default-checked checkedChildren="Enabled" unCheckedChildren="Disabled" @change="supplierOnChange" @click="switchStatus(data)"/>
                                </div>
                                <div v-else >
                                    <a-switch checkedChildren="Enabled" unCheckedChildren="Disabled" @change="supplierOnChange"  @click="switchStatus(data)"/>
                                </div>
                            </template>
                        </a-table>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="4">
                    <span slot="tab">
                        Product Manufacturers
                    </span>
						<div class="requestActions">
                           <a-button @click="showManufacturerModal" style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;" icon="plus">
                            Add New Manufacturer
                        </a-button>
                        </div>
                    <div>
                        <a-table
                        :columns="manufacturersColumns"
                        :data-source="tableManufacturerData"
                        :loading="tableLoading"
                        :pagination="pagination"
                        class="orderTable"
                        >
                            <template slot="action" slot-scope="data">
                                <a-dropdown>
                                    <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                        <a-icon style="font-size:25px;" type="ellipsis" />
                                    </a>
                                    <a-menu slot="overlay">
                                        <a-menu-item>
                                            <a @click="showUpdateManufacturerModel(data)">Edit Manufacturer?</a>
                                        </a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                            </template>
                             <template slot="status" slot-scope="data">
                                <div v-if="data.status === 1">
                                    <a-switch default-checked checkedChildren="Enabled" unCheckedChildren="Disabled" @change="manufacturerOnChange" @click="switchManufacturerStatus(data)"/>
                                </div>
                                <div v-else >
                                    <a-switch checkedChildren="Enabled" unCheckedChildren="Disabled" @change="manufacturerOnChange"  @click="switchManufacturerStatus(data)"/>
                                </div>
                            </template>
                        </a-table>
                    </div>
                </a-tab-pane> -->
                    </a-tabs>
                </div>
                <!-- Add Group Modal -->
                <a-modal class="modalStyle" :visible="addGroupVisible" :footer="null" @cancel="handleAddGroupCancel">

                    <p
                        style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                        Add New Group</p>
                    <div>
                        <a-form-model ref="addGroupForm" :model="addGroupModel" :rules="rules">
                            <a-row>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Name" ref="name" prop="name">
                                        <a-input class="" v-model="addGroupModel.name" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Description" ref="description" prop="description">
                                        <a-input class="" v-model="addGroupModel.description" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>

                            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                                <!-- <a-spin class="spinner" :spinning="loading" /> -->
                            </div>

                            <a-form-model-item
                                style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                                <a-button :loading="loading" @click="handleAddGroupSubmit"
                                    style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                    Add Group
                                </a-button>
                            </a-form-model-item>

                        </a-form-model>
                    </div>
                </a-modal>
                <!-- Update Group Modal -->
                <a-modal class="modalStyle" :visible="updateGroupVisible" :footer="null"
                    @cancel="handleUpdateGroupCancel">

                    <p
                        style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                        Edit Group</p>
                    <div>
                        <a-form-model ref="updateGroupForm" :model="updateGroupModel" :rules="rules">
                            <a-row>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Name" ref="name" prop="name">
                                        <a-input class="" v-model="updateGroupModel.name" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Description" ref="description" prop="description">
                                        <a-input class="" v-model="updateGroupModel.description" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>

                            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                                <a-spin class="spinner" :spinning="loading" />
                            </div>

                            <a-form-model-item
                                style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                                <a-button @click="handleUpdateGroupSubmit"
                                    style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                    Edit Group
                                </a-button>
                            </a-form-model-item>

                        </a-form-model>
                    </div>
                </a-modal>
                <!-- Add Category -->
                <a-modal class="modalStyle" :visible="addCategoryVisible" :footer="null"
                    @cancel="handleAddCategoryCancel">

                    <p
                        style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                        Add New Category</p>
                    <div>
                        <a-form-model ref="addCategoryForm" :model="addCategoryModel" :rules="rules">
                            <a-row>
                                <a-col :span="10" :offset="1">
                                    <a-form-model-item label="Category Name" ref="categoryName" prop="categoryName">
                                        <a-input class="" v-model="addCategoryModel.categoryName" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="10" :offset="2">
                                    <a-form-model-item label="Category Description" ref="categoryDescription"
                                        prop="categoryDescription">
                                        <a-input class="" v-model="addCategoryModel.categoryDescription" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="10" :offset="1">
                                    <a-form-model-item label="Category Group" ref="categoryGroup" prop="categoryGroup">
                                        <a-select v-model="addCategoryModel.categoryGroup"
                                            placeholder="please select your group">
                                            <a-select-option v-for="group in tableGroupData" :key="group.id"
                                                v-bind:value="group.id">
                                                {{ group.name }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="10" :offset="2">
                                    <a-form-model-item label="Category Restriction" ref="isRestricted"
                                        prop="isRestricted">
                                        <a-select v-model="addCategoryModel.isRestricted"
                                            placeholder="please select your option">
                                            <a-select-option value="true">
                                                Yes
                                            </a-select-option>
                                            <a-select-option value="false">
                                                No
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Category Commission" ref="categoryCommission"
                                        prop="categoryCommission">

                                        <a-input-number class="numberInput"
                                            v-model="addCategoryModel.categoryCommission" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>

                            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                                <!-- <a-spin class="spinner" :spinning="loading" /> -->
                            </div>

                            <a-form-model-item
                                style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                                <a-button :loading="loading" @click="handleAddCategorySubmit"
                                    style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                    Add Category
                                </a-button>
                            </a-form-model-item>

                        </a-form-model>
                    </div>
                </a-modal>
                <!-- Update Category -->
                <a-modal class="modalStyle" :visible="updateCategoryVisible" :footer="null"
                    @cancel="handleUpdateCategoryCancel">

                    <p
                        style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                        Edit Category</p>
                    <div>
                        <a-form-model ref="updateCategoryForm" :model="updateCategoryModel" :rules="rules">
                            <a-row>
                                <a-col :span="10" :offset="1">
                                    <a-form-model-item label="Category Name" ref="categoryName" prop="categoryName">
                                        <a-input class="" v-model="updateCategoryModel.categoryName" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="10" :offset="2">
                                    <a-form-model-item label="Category Description" ref="categoryDescription"
                                        prop="categoryDescription">
                                        <a-input class="" v-model="updateCategoryModel.categoryDescription" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="10" :offset="1">
                                    <a-form-model-item label="Category Group" ref="categoryGroup" prop="categoryGroup">
                                        <a-select v-model="updateCategoryModel.categoryGroup"
                                            placeholder="please select your group">
                                            <a-select-option v-for="group in tableGroupData" :key="group.id"
                                                v-bind:value="group.id">
                                                {{ group.name }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="10" :offset="2">
                                    <a-form-model-item label="Category Restriction" ref="isRestricted"
                                        prop="isRestricted">
                                        <a-select v-model="updateCategoryModel.isRestricted"
                                            placeholder="please select your option">
                                            <a-select-option value="true">
                                                Yes
                                            </a-select-option>
                                            <a-select-option value="false">
                                                No
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Category Commission" ref="categoryCommission"
                                        prop="categoryCommission">
                                        <a-input-number class="numberInput"
                                            v-model="updateCategoryModel.categoryCommission" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>

                            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                                <a-spin class="spinner" :spinning="loading" />
                            </div>

                            <a-form-model-item
                                style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                                <a-button @click="handleEditCategorySubmit"
                                    style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                    Edit Category
                                </a-button>
                            </a-form-model-item>

                        </a-form-model>
                    </div>
                </a-modal>
                <!-- Add Supplier -->
                <a-modal class="modalStyle" :visible="addSupplierVisible" :footer="null"
                    @cancel="handleAddSupplierCancel">

                    <p
                        style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                        Add Supplier</p>
                    <div>
                        <a-form-model ref="addSupplierForm" :model="addSupplierModel" :rules="rules">
                            <a-row>
                                <a-col :span="10" :offset="1">
                                    <a-form-model-item label="Supplier Name" ref="supplierName" prop="supplierName">
                                        <a-input class="" v-model="addSupplierModel.supplierName" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="10" :offset="2">
                                    <a-form-model-item label="Supplier Address" ref="supplierAddress"
                                        prop="supplierAddress">
                                        <a-input class="" v-model="addSupplierModel.supplierAddress" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="10" :offset="1">
                                    <a-form-model-item label="Supplier Phone Number" ref="supplierPhoneNumber"
                                        prop="supplierPhoneNumber">
                                        <a-input class="" v-model="addSupplierModel.supplierPhoneNumber" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="10" :offset="2">
                                    <a-form-model-item label="Supplier Description" ref="supplierDescription"
                                        prop="supplierDescription">
                                        <a-input class="" v-model="addSupplierModel.supplierDescription" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>


                            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                                <a-spin class="spinner" :spinning="loading" />
                            </div>

                            <a-form-model-item
                                style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                                <a-button @click="handleAddSupplierSubmit"
                                    style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                    Add Supplier
                                </a-button>
                            </a-form-model-item>

                        </a-form-model>
                    </div>
                </a-modal>
                <!-- Update Supplier -->
                <a-modal class="modalStyle" :visible="updateSupplierVisible" :footer="null"
                    @cancel="handleUpdateSupplierCancel">

                    <p
                        style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                        Edit Supplier</p>
                    <div>
                        <a-form-model ref="updateSupplierForm" :model="updateSupplierModel" :rules="rules">
                            <a-row>
                                <a-col :span="10" :offset="1">
                                    <a-form-model-item label="Supplier Name" ref="supplierName" prop="supplierName">
                                        <a-input class="" v-model="updateSupplierModel.supplierName" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="10" :offset="2">
                                    <a-form-model-item label="Supplier Address" ref="supplierAddress"
                                        prop="supplierAddress">
                                        <a-input class="" v-model="updateSupplierModel.supplierAddress" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="10" :offset="1">
                                    <a-form-model-item label="Supplier Phone Number" ref="supplierPhoneNumber"
                                        prop="supplierPhoneNumber">
                                        <a-input class="" v-model="updateSupplierModel.supplierPhoneNumber" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="10" :offset="2">
                                    <a-form-model-item label="Supplier Description" ref="supplierDescription"
                                        prop="supplierDescription">
                                        <a-input class="" v-model="updateSupplierModel.supplierDescription" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>

                            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                                <a-spin class="spinner" :spinning="loading" />
                            </div>

                            <a-form-model-item
                                style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                                <a-button @click="handleEditSupplierSubmit"
                                    style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                    Edit Supplier
                                </a-button>
                            </a-form-model-item>

                        </a-form-model>
                    </div>
                </a-modal>
                <!-- Add Manufacturer -->
                <a-modal class="modalStyle" :visible="addManufacturerVisible" :footer="null"
                    @cancel="handleAddManufacturerCancel">

                    <p
                        style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                        Add Manufacturer</p>
                    <div>
                        <a-form-model ref="addManufacturerForm" :model="addManufacturerModel" :rules="rules">
                            <a-row>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Manufacturer Name" ref="manufacturerName"
                                        prop="manufacturerName">
                                        <a-input class="" v-model="addManufacturerModel.manufacturerName" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Manufacturer Description" ref="manufacturerDescription"
                                        prop="manufacturerDescription">
                                        <a-input class="" v-model="addManufacturerModel.manufacturerDescription" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>

                            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                                <!-- <a-spin class="spinner" :spinning="loading" /> -->
                            </div>

                            <a-form-model-item
                                style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                                <a-button :loading="loading" @click="handleManufacturerSubmit"
                                    style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                    Add Manufacturer
                                </a-button>
                            </a-form-model-item>

                        </a-form-model>
                    </div>
                </a-modal>
                <!-- Update Manyfacturer -->
                <a-modal class="modalStyle" :visible="updateManufacturerVisible" :footer="null"
                    @cancel="handleUpdateManufacturerCancel">

                    <p
                        style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                        Edit Manufacturer</p>
                    <div>
                        <a-form-model ref="updateManufacturerForm" :model="updateManufacturerModel" :rules="rules">
                            <a-row>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Manufacturer Name" ref="manufacturerName"
                                        prop="manufacturerName">
                                        <a-input class="" v-model="updateManufacturerModel.manufacturerName" />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="22" :offset="1">
                                    <a-form-model-item label="Manufacturer Description" ref="manufacturerDescription"
                                        prop="manufacturerDescription">
                                        <a-input class="" v-model="updateManufacturerModel.manufacturerDescription" />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>

                            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                                <a-spin class="spinner" :spinning="loading" />
                            </div>

                            <a-form-model-item
                                style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                                <a-button @click="handleUpdateManufacturerSubmit"
                                    style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                    Edit Manufacturer
                                </a-button>
                            </a-form-model-item>

                        </a-form-model>
                    </div>
                </a-modal>
            </div>
        </a-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
// import XLSX from "xlsx";

const groupColumns = [
  {
    title: 'Group ID',
    // width: 150,
    key: 'id',
    dataIndex: 'id',
  },
  {
    title: 'Group Name',
    key: 'name',
    dataIndex: 'name',
    // width: 200,
  },
  {
    title: 'Group Description',
    dataIndex: 'description',
     key: 'description',
    //  width: 150,
    },
    
  {
    title: 'Created At',
    dataIndex: 'dateCreated',
    key: 'dateCreated',
    // width: 150,
  },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  },
];

const categoryColumns = [
    {
    title: 'Category ID',
    // width: 150,
    key: 'id',
    dataIndex: 'id',
  },
  {
    title: 'Category Name',
    // width: 150,
    key: 'name',
    dataIndex: 'name',
  },
  {
    title: 'Category Description',
    // width: 150,
    key: 'description',
    dataIndex: 'description',
  },
  {
    title: 'Restricted',
    // width: 150,
    key: 'isRestricted',
    dataIndex: 'isRestricted',
    scopedSlots: { customRender: 'isRestricted' }
  },
  {
    title: 'Created At',
    // width: 150,
    key: 'dateCreated',
    dataIndex: 'dateCreated',
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  },
]

const supplierColumns = [
    {
        title: 'Supplier ID',
        // width: 150,
        key: 'id',
        dataIndex: 'id',
    },
    {
        title: 'Supplier Name',
        // width: 150,
        key: 'name',
        dataIndex: 'name',
    },
    {
        title: 'Region',
        // width: 150,
        key: 'address',
        dataIndex: 'address',
    },
    {
        title: 'Created At',
        // width: 150,
        key: 'dateCreated',
        dataIndex: 'dateCreated',
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' }
    },
    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },

]

const manufacturersColumns = [
    {
        title: 'Manufacturer ID',
        // width: 150,
        key: 'id',
        dataIndex: 'id',
    },
    {
        title: 'Manufacturer Name',
        // width: 150,
        key: 'name',
        dataIndex: 'name',
    },
    {
        title: 'Manufacturer Description',
        // width: 150,
        key: 'description',
        dataIndex: 'description',
    },
    {
        title: 'Created At',
        // width: 150,
        key: 'dateCreated',
        dataIndex: 'dateCreated',
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' }
    },
    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },
]

export default {
    name: "ProductsManagement",
    data(){
        return{
            tableGroupData: [],
            tableCategoryData: [],
            tableSupplierData: [],
            tableManufacturerData: [],
            addGroupVisible: false,
            addCategoryVisible: false,
            addSupplierVisible: false,
            updateGroupVisible: false,
            updateSupplierVisible: false,
            updateCategoryVisible: false,
            addManufacturerVisible: false,
            updateManufacturerVisible: false,
            isSupplierEnabled: Boolean,
            isManufacturerEnabled: Boolean,
            tableLoading: false,
            pagination: {
                pageSize:20
            },
            addGroupModel:{
                name: '',
                description: ''
            },
            updateGroupModel:{
                name: '',
                description: ''
            },
            addCategoryModel:{
                categoryName: '',
                categoryDescription: '',
                categoryGroup: '',
                isRestricted: '',
                categoryCommission: ''
            },
            updateCategoryModel:{
                categoryName: '',
                categoryDescription: '',
                categoryGroup: '',
                isRestricted: '',
                categoryCommission: ''
            },
            addSupplierModel:{
                supplierName: '',
                supplierAddress: '',
                supplierPhoneNumber:'',
                supplierDescription: ''
            },
            updateSupplierModel: {
                supplierName: '',
                supplierAddress: '',
                supplierPhoneNumber:'',
                supplierDescription: ''
            },
            addManufacturerModel: {
                manufacturerName:'',
                manufacturerDescription: ''
            },
            updateManufacturerModel: {
                manufacturerName:'',
                manufacturerDescription: ''
            },
            selectedGroup: {},
            selectCategory: {},
            selectedSupplier: {},
            selectedManufacturer: {},
            loading: false,
            groupColumns,
            categoryColumns,
            supplierColumns,
            manufacturersColumns,
            rules:{
                notes: [
                    { required: true, message: 'Please this field cannot be empty' , trigger: 'change'},
                ],
                name: [
                    { required: true, message: 'Please enter name' , trigger: 'change'},
                ],
                
                manufacturerName: [
                    { required: true, message: 'Please enter name' , trigger: 'change'},
                ],
                description: [
                    { required: true, message: 'Please enter description' , trigger: 'change'},
                ],
                manufacturerDescription: [
                    { required: true, message: 'Please enter description' , trigger: 'change'},
                ],
                supplierName: [
                    { required: true, message: 'Please enter name' , trigger: 'change'},
                ],
                supplierAddress: [
                    { required: true, message: 'Please enter address' , trigger: 'change'},
                ],
                supplierPhoneNumber: [
                    { required: true, message: 'Please enter phone number' , trigger: 'change'},
                ],
                supplierDescription: [
                    { required: true, message: 'Please enter description' , trigger: 'change'},
                ],
                categoryName: [
                    { required: true, message: 'Please enter name' , trigger: 'change'},
                ],
                categoryDescription: [
                    { required: true, message: 'Please enter description' , trigger: 'change'},
                ],
                categoryGroup: [
                    { required: true, message: 'Please select your option' , trigger: 'change'},
                ],
                isRestricted: [
                    { required: true, message: 'Please select your option' , trigger: 'change'},
                ],
                categoryCommission: [
                    { required: true, message: 'Please enter commission', trigger: 'change' },
                    {   
                            pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),  
                            message: 'Please enter valid number', 
                            trigger: 'change'
                    },
                ],
            }
        }
    },
    methods: {
        ...mapActions(['getAllProductsMgtData','addNewGroup','addProductManufacturer','updateProductSupplier','updateProductManufacturer','updateGroup','addCategory','updateCategory','addProductSupplier']),
    
        showSuccessAlert(message) {
        this.$notification['success']({
            message: message,
        });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        handleAddGroupCancel(){
            this.addGroupVisible = false;
        },
        handleUpdateSupplierCancel(){
            this.updateSupplierVisible = false;
        },
        handleUpdateGroupCancel(){
            this.updateGroupVisible = false;
        },
        handleAddCategoryCancel(){
            this.addCategoryVisible = false;
        },
        handleUpdateCategoryCancel(){
            this.updateCategoryVisible = false;
        },
        handleAddSupplierCancel(){
            this.addSupplierVisible = false;
        },
        handleAddManufacturerCancel(){
            this.addManufacturerVisible = false;
        },
        handleUpdateManufacturerCancel(){
            this.updateManufacturerVisible = false;
        },
        supplierOnChange(checked){
            this.isSupplierEnabled = checked
        },
        manufacturerOnChange(checked){
            this.isManufacturerEnabled = checked
        },
        showGroupModal(){
            this.addGroupVisible = true;
        },
        showCategoryModal(){
            this.addCategoryVisible = true;
        },
        showSupplierModal(){
            this.addSupplierVisible = true;
        },
        showCategoryModel(data){
            this.selectCategory = data;
            this.updateCategoryModel.categoryName = data.name
            this.updateCategoryModel.categoryDescription = data.description
            this.updateCategoryModel.categoryGroup = data.groupId
            this.updateCategoryModel.categoryCommission = data.commission
            this.updateCategoryModel.isRestricted = data.isRestricted === true ? 'true' : 'false'
            this.updateCategoryVisible = true;
        },
        showManufacturerModal(){
            this.addManufacturerVisible = true;
        },
        showUpdateSupplierModel(data){
            this.selectedSupplier = data
            this.updateSupplierModel.supplierName = data.name
            this.updateSupplierModel.supplierAddress = data.address
            this.updateSupplierModel.supplierPhoneNumber = data.metadata.phoneNumber ? data.metadata.phoneNumber : ''
            this.updateSupplierModel.supplierDescription = data.metadata.description ? data.metadata.description : ''
            this.updateSupplierVisible = true;
        },
        showUpdateManufacturerModel(data){
            this.selectedManufacturer = data
            this.updateManufacturerModel.manufacturerName = data.name
            this.updateManufacturerModel.manufacturerDescription = data.description
            this.updateManufacturerVisible = true;
        },
        showUpdateGroupModal(data){
            this.selectedGroup = data;
            this.updateGroupModel.name = data.name;
            this.updateGroupModel.description = data.description;
            this.updateGroupVisible = true;
        },
        handleAddGroupSubmit(){
            this.$refs.addGroupForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                     const request = {
                         name: this.addGroupModel.name,
                         description: this.addGroupModel.description
                     }

                    
                    this.addNewGroup(request).then(response => {
                        
                        this.loading = false;
                        if(response.status === 200){
                            this.getProductsMgtData();
                            this.showSuccessAlert("New Group Added Successfully")
                            this.$refs.addGroupForm.resetFields();
                            this.addGroupVisible = false;
                        }else{
                            this.showErrorAlert(response.data.messages)
                        }
                    },
                    error =>{
                        this.loading = false
                        this.showErrorAlert(JSON.stringify(error))
                    })                    
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
        },
        handleUpdateGroupSubmit(){
            this.$refs.updateGroupForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                     const request = {
                         id: this.selectedGroup.id,
                         data: {
                            name: this.updateGroupModel.name,
                            description: this.updateGroupModel.description
                         }
                     }

                    
                    this.updateGroup(request).then(response => {
                        
                        this.loading = false;
                        if(response.status === 200){
                            this.getProductsMgtData();
                            this.showSuccessAlert("New Group Updated Successfully")
                            this.updateGroupVisible = false;
                        }else{
                            this.showErrorAlert(response.data.messages)
                        }
                    },
                    error =>{
                        this.loading = false
                        this.showErrorAlert(JSON.stringify(error))
                    })                    
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
        },
        handleAddCategorySubmit(){
            this.$refs.addCategoryForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        const request = {
                            id: this.addCategoryModel.categoryGroup,
                            data: {
                                name: this.addCategoryModel.categoryName,
                                description: this.addCategoryModel.categoryDescription,
                                commission: this.addCategoryModel.categoryCommission,
                                isRestricted: this.addCategoryModel.isRestricted === 'true' ? true : false
                            }
                        }

                        
                        this.addCategory(request).then(response => {
                            
                            this.loading = false;
                            if(response.status === 200){
                                this.getProductsMgtData();
                                this.showSuccessAlert("New Category Created Successfully")
                                this.addCategoryVisible = false;
                                this.$refs.addCategoryForm.resetFields();
                            }else{
                                this.showErrorAlert(response.data.messages)
                            }
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })                    
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
            });
        },
        handleEditCategorySubmit(){
            this.$refs.updateCategoryForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        const request = {
                            id: this.selectCategory.id,
                            data: {
                                groupId: this.updateCategoryModel.categoryGroup,
                                name: this.updateCategoryModel.categoryName,
                                description: this.updateCategoryModel.categoryDescription,
                                commission: this.updateCategoryModel.categoryCommission,
                                isRestricted: this.updateCategoryModel.isRestricted === 'true' ? true : false
                            }
                        }
                        
                        this.updateCategory(request).then(response => {
                            
                            this.loading = false;
                            if(response.status === 200){
                                this.getProductsMgtData();
                                this.showSuccessAlert("Category Updated Successfully")
                                this.updateCategoryVisible = false;
                            }else{
                                this.showErrorAlert(response.data.messages)
                            }
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })                    
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
            });
        },
        handleAddSupplierSubmit(){
            this.$refs.addSupplierForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        const request = {
                            name:  this.addSupplierModel.supplierName,
                            address: this.addSupplierModel.supplierAddress,
                            metadata:{
                                phoneNumber: this.addSupplierModel.supplierPhoneNumber,
                                description: this.addSupplierModel.supplierDescription,
                            },
                            status: 1
                        }
                       
                        
                        this.addProductSupplier(request).then(response => {
                            
                            this.loading = false;
                            if(response.status === 200){
                                this.getProductsMgtData();
                                this.showSuccessAlert("Supplier Added Successfully")
                                this.addSupplierVisible = false;
                                this.$refs.addSupplierForm.resetFields();
                            }else{
                                this.showErrorAlert(response.data.messages)
                            }
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })                    
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
            });
        },
        handleManufacturerSubmit(){
            this.$refs.addManufacturerForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        const request = {
                            name:  this.addManufacturerModel.manufacturerName,
                            description: this.addManufacturerModel.manufacturerDescription,
                            status: 1
                        }
       
                        
                        this.addProductManufacturer(request).then(response => {
                            
                            this.loading = false;
                            if(response.status === 200){
                                this.getProductsMgtData();
                                this.showSuccessAlert("Manufacturer Added Successfully")
                                this.addManufacturerVisible = false;
                                this.$refs.addManufacturerForm.resetFields();
                            }else{
                                this.showErrorAlert(response.data.messages)
                            }
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })                    
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
            });
        },
        handleEditSupplierSubmit(){
            this.$refs.updateSupplierForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        const request = {
                            id: this.selectedSupplier.id,
                            data: {
                                name:  this.updateSupplierModel.supplierName,
                                address: this.updateSupplierModel.supplierAddress,
                                metadata:{
                                    phoneNumber: this.updateSupplierModel.supplierPhoneNumber,
                                    description: this.updateSupplierModel.supplierDescription,
                                },
                                status: this.selectedSupplier.status
                            }
                        }
                       
                        
                        this.updateProductSupplier(request).then(response => {
                            
                            this.loading = false;
                            if(response.status === 200){
                                this.getProductsMgtData();
                                this.showSuccessAlert("Supplier Updated Successfully")
                                this.updateSupplierVisible = false;
                                this.$refs.updateSupplierForm.resetFields();
                            }else{
                                this.showErrorAlert(response.data.messages)
                            }
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })                    
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
            });
        },
        handleUpdateManufacturerSubmit(){
            this.$refs.updateManufacturerForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        const request = {
                            id: this.selectedManufacturer.id,
                            data: {
                                name:  this.updateManufacturerModel.manufacturerName,
                                description: this.updateManufacturerModel.manufacturerDescription,
                                status: this.selectedManufacturer.status
                            }
                        }

                        
                        this.updateProductManufacturer(request).then(response => {
                            
                            this.loading = false;
                            if(response.status === 200){
                                this.getProductsMgtData();
                                this.showSuccessAlert("Manufacturer Updated Successfully")
                                this.updateManufacturerVisible = false;
                            }else{
                                this.showErrorAlert(response.data.messages)
                            }
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })                    
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
            });
        },
        switchStatus(data){
            this.tableLoading = true
        
            const request = {
                id: data.id,
                data: {
                    name:  data.name,
                    address: data.address,
                    metadata:{
                        phoneNumber: data.metadata.phoneNumber,
                        description: data.metadata.description,
                    },
                    status: this.isSupplierEnabled === true ? 1 : 0
                }
            }
            
            
            this.updateProductSupplier(request).then(response => {
                
                this.tableLoading = false;
                if(response.status === 200){
                    this.getProductsMgtData();
                    if(this.isSupplierEnabled){
                        this.showSuccessAlert(`Supplier [ ${data.name} ] Enabled Successfully`)
                    }else{
                        this.showSuccessAlert(`Supplier [ ${data.name} ] Disabled Successfully`)
                    }
                }else{
                    this.tableLoading = false;
                    this.showErrorAlert(response.data.messages)
                }
            },
            error =>{
                this.tableLoading = false
                this.showErrorAlert(JSON.stringify(error))
            }) 
        },
        switchManufacturerStatus(data){
            this.tableLoading = true
            const request = {
                id: data.id,
                data: {
                    name:  data.name,
                    description: data.description,
                    status: this.isManufacturerEnabled === true ? 1 : 0
                }
            }

            this.updateProductManufacturer(request).then(response => {
                
                this.tableLoading = false;
                if(response.status === 200){
                    this.getProductsMgtData();
                    if(this.isManufacturerEnabled){
                        this.showSuccessAlert(`Manufacturer [ ${data.name} ] Enabled Successfully`)
                    }else{
                        this.showSuccessAlert(`Manufacturer [ ${data.name} ] Disabled Successfully`)
                    }
                }else{
                    this.tableLoading = false;
                    this.showErrorAlert(response.data.messages)
                }
            },
            error =>{
                this.tableLoading = false
                this.showErrorAlert(JSON.stringify(error))
            }) 
            
        },
        getAllGroupsData(response){
            if(response.status === 200){
                this.tableGroupData = response.data.data.map(group => ({
                    id: group.id,
                    key: group.id,
                    name: group.name,
                    description: group.description ? group.description : 'N/A',
                    dateCreated: moment(group.dateCreated).format('DD-MM-YYYY'),
                    action: group
                }))
            }else{
                console.log("Error | " , response)
            }
        },
        getAllCategoriesData(response){
            if(response.status === 200){
                
                const result = response.data.data.map(category => ({
                    id: category.id,
                    key: category.id,
                    name: category.name,
                    description: category.description ? category.description : 'N/A',
                    isRestricted: category.isRestricted === true ? 'Yes' : 'No',
                    dateCreated: moment(category.createdAt).format('DD-MM-YYYY'),
                    action: category
                }))
                this.tableCategoryData =  _.orderBy(result, ['dateCreated'],['desc'])
            }else{
                console.log("Error | " , response)
            }
        },
        getAllSuppliersData(response){
             if(response.status === 200){
                
                this.tableSupplierData = response.data.data.map(supplier => ({
                    id: supplier.id,
                    key: supplier.id,
                    name: supplier.name,
                    address: supplier.address ? supplier.address : 'N/A',
                    status: supplier,
                    isRestricted: supplier.isRestricted === true ? 'Yes' : 'No',
                    dateCreated: moment(supplier.createdAt).format('DD-MM-YYYY'),
                    action: supplier
                }))
                // this.tableCategoryData =  _.orderBy(result, ['dateCreated'],['desc'])
            }else{
                console.log("Error | " , response)
            }
        },
        getAllManufacturersData(response){
            if(response.status === 200){
                
                this.tableManufacturerData = response.data.data.map(manufacturer => ({
                    id: manufacturer.id,
                    key: manufacturer.id,
                    name: manufacturer.name,
                    description: manufacturer.description,
                    status: manufacturer,
                    dateCreated: moment(manufacturer.createdAt).format('DD-MM-YYYY'),
                    action: manufacturer
                }))
                // this.tableCategoryData =  _.orderBy(result, ['dateCreated'],['desc'])
            }else{
                console.log("Error | " , response)
            }
        },
        async getProductsMgtData(){
            this.tableLoading =  true;
            const response = await this.getAllProductsMgtData();

            this.getAllGroupsData(response[0])
            this.getAllCategoriesData(response[1])
            this.getAllSuppliersData(response[2])
            this.getAllManufacturersData(response[3])

            this.tableLoading =  false;
        }

    },
    computed:{
        
    
    },
    created() {
        if(this.getProductsMgtData){
            this.getProductsMgtData();
        }
    }
}
</script>

<style scoped>
.requestActions{
    display: flex;
    justify-content:flex-end;
    margin-bottom: 20px;
}

.actions{
    display: flex;
    justify-content:space-between;
}

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;

}

.card-container >>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}
.card-container >>> .ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}

.card-container >>> .ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

 .spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

button:hover{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}
.orderTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.orderTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
.numberInput{
    width: 100%;
    border-radius: 5px;
}

 .spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}


.orderTable >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.ant-switch-checked {
    background-color: #418a49;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar {
    border: none;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    height: 40px;
    color: #111827;
    background: transparent;
    border-radius: 8px;
    max-width: 35%;
    margin-right: 12px;
}


.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #fff;
    background: #418a49;
    border-bottom: none;
    border-radius: 8px;
    max-width: 35%;
}
</style>